<template>
  <div class="header" :key="mobile">
    <v-toolbar
      height="60"
      class="navbar-desktop"
      :class="{ baned: userBaned }"
      color="primary"
      :flat="$vuetify.breakpoint.mdAndDown"
    >
      <div class="container main" :class="{ 'main--small': mobile }">
        <HeaderAvatarMenu v-if="mobile" @exit="onExit" />
        <HeaderLogo v-else :mobile-menu="mobile" id="logo" />
        <div class="navigations">
          <transition-group
            name="fade"
            mode="out-in"
            appear
            id="menu_container"
            :class="mobile ? 'abs' : ''"
          >
            <template v-if="userType === 'superadmin' || userRoleAbilities">
              <template v-for="(button, key) in buttons">
                <v-btn
                  v-if="button.access !== undefined ? button.access : true"
                  :key="'pageButton_' + key"
                  :to="{ name: button.toName }"
                  class="navigations_btn f16"
                  :class="{ icon: button.toName === 'Setting' }"
                  text
                >
                  <BaseIcon v-if="button.icon" :icon="button.icon" color="#ffffff" />
                  <template v-if="button.toName !== 'Setting'">
                    {{ button.text }}
                  </template>
                </v-btn>
              </template>
            </template>
            <template v-else>
              <v-skeleton-loader
                v-for="(button, key) in buttons"
                :key="'loader_' + key"
                class="skeleton_btn"
                tile
                v-bind="{}"
                type="button"
              ></v-skeleton-loader>
            </template>
          </transition-group>
          <HeaderLogo v-if="mobile" :mobile-menu="mobile_menu" id="logo" />
        </div>
        <div class="main_right" id="main_right">
          <HeaderChat />
          <HeaderNotification />
          <v-btn
            v-if="mobile"
            text
            color="white"
            @click="changeDrawer"
            class="mr-n3 mobile_menu-btn"
          >
            <div class="d-flex align-center">
              <svg
                v-if="drawer"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                aria-hidden="true"
                width="32"
                height="32"
                viewBox="0 0 24 24"
                style="max-height: 32px"
              >
                <g fill="none">
                  <path
                    d="M17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41L17.59 5z"
                    fill="white"
                  />
                </g>
              </svg>
              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                aria-hidden="true"
                width="32"
                height="32"
                viewBox="0 0 48 48"
                style="max-height: 32px"
              >
                <g fill="white">
                  <path d="M6 22h36v4H6z" />
                  <path d="M6 10h36v4H6z" />
                  <path d="M6 34h36v4H6z" />
                </g>
              </svg>
            </div>
          </v-btn>
          <HeaderAvatarMenu v-else @exit="onExit" />
        </div>
      </div>
    </v-toolbar>
    <HeaderMobileMenu :drawer.sync="drawer" :buttons="buttons" />
    <HeaderLogoutModal :modal="modal_logout" @exit="onExit" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import HeaderLogo from 'components/header/HeaderLogo'
import HeaderAvatarMenu from 'components/header/HeaderAvatarMenu'
import HeaderLogoutModal from 'components/header/HeaderLogoutModal'
import HeaderMobileMenu from 'components/header/HeaderMobileMenu'
import HeaderNotification from 'components/header/notification/HeaderNotification'
import HeaderChat from 'components/header/HeaderChat'
import pages_config from '~/configs/pages'

export default {
  name: 'Header',
  components: {
    HeaderLogo,
    HeaderAvatarMenu,
    HeaderLogoutModal,
    HeaderMobileMenu,
    HeaderNotification,
    HeaderChat,
  },
  data() {
    return {
      drawer: false,
      modal_logout: false,
      mobile_menu: false,
      navigation: 123,
    }
  },
  computed: {
    ...mapState(['configData']),
    ...mapGetters(['apiDomain']),
    ...mapGetters('user', ['userData', 'userRoleAbilities', 'userType', 'userBaned']),
    mobile() {
      return this.checkMobile(false)
    },
    buttons() {
      return pages_config({isArray: true})
    },
  },
  watch: {
    mobile() {
      if (!this.mobile && this.drawer) {
        this.drawer = false
      }
    },
  },
  mounted() {
    this.checkMobile(true)
    if (!this.mobile && this.drawer) {
      this.drawer = false
    }
  },
  methods: {
    onExit(value) {
      this.modal_logout = value
    },
    changeDrawer() {
      this.navigation++
      this.drawer = !this.drawer
    },
    checkMobile(reset) {
      let width = 180
      let temp = {
        avatar: null,
        logo: null,
        menu_container: null,
        main_right: null,
      }
      for (let i in temp) {
        temp[i] = document.getElementById(i)
        if (temp[i] && temp[i].offsetWidth) width = width + temp[i].offsetWidth
      }
      this.mobile_menu = width > this.$vuetify.breakpoint.width
      if (!reset) return this.$vuetify.breakpoint.smAndDown || this.mobile_menu
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  overflow: hidden;
}

.v-toolbar {
  max-width: 100vw;
}

.br15 {
  border-radius: 15px !important;
}

.white--text {
  color: white !important;

  :deep() * {
    color: white !important;
  }
}

header:deep() {
  height: max-content;
  position: fixed;
  z-index: 200;
  width: 100%;

  &.baned {
    z-index: 199;
  }

  .v-toolbar__content {
    padding: 0;
    //overflow: hidden;

    .main {
      display: grid;
      grid-template-columns: auto 1fr auto;
      grid-column-gap: 30px;
      align-items: center;
      transition: 0.3s;
      & > * {
        height: inherit;
      }

      &_right {
        display: flex;
        gap: 10px;
        justify-content: flex-end;
        height: inherit;
        & > * {
          height: inherit !important;
        }
        @media screen and (max-width: 450px) {
          gap: 0px;
          & > * {
            width: 45px;
            min-width: 40px;
          }
          button {
            padding: 0;
          }
        }
      }
    }

    .container {
      height: inherit;
    }
  }
}

.navigations {
  width: 100%;
  position: relative;
  height: inherit;
  display: flex;

  &_btn {
    height: 100% !important;
  }

  .abs {
    position: absolute;
    top: -200px;
  }

  & > span {
    white-space: nowrap;
  }

  .skeleton_btn {
    height: 100%;

    .v-skeleton-loader__button {
      height: inherit;
      width: 100px;
    }
  }

  :deep().navigations_btn {
    height: 100%;
    color: #a2d5f1;
    font-weight: normal;
    font-size: 17px;
    text-transform: capitalize;
    transition: 0.3s;
    border-radius: 0;
    position: relative;

    svg {
      width: 24px;
      min-height: 5px;

      path {
        fill: #a2d5f1;
      }
    }

    &:hover {
      color: #ffffff;

      svg {
        path {
          fill: #ffffff;
        }
      }
    }

    &.v-btn--active {
      color: #ffffff;

      svg {
        path {
          fill: #ffffff;
        }
      }

      &:hover {
        color: #ffffff;

        svg {
          path {
            fill: #ffffff;
          }
        }
      }

      .v-btn__content {
        height: inherit;

        &::before {
          content: '';
          height: 3px;
          background: #ffffff;
          width: 50%;
          max-width: 69px;
          position: absolute;
          transform: translateX(-50%);
          left: 50%;
          bottom: 0;
        }
      }
    }

    &:not(.icon) {
      .v-btn__content {
        display: grid;
        grid-template-columns: auto auto;
        column-gap: 10px;
      }
    }
  }
}

.v-menu__content {
  filter: drop-shadow(0px 4px 4px rgba(37, 120, 173, 0.2));
  box-shadow: none;
}
</style>
